'use strict';

module.exports = {
    aggregatedEventsForPlatformNotifications: 'arn:aws:sns:us-east-1:550107995187:AggregatedEventsForPlatformNotifications'
};